export default "__VITE_ASSET__BOMqSkRF__"